import { useEffect } from "react";

export const useLockBodyScroll = (isLocked?: boolean): void => {
    useEffect((): (() => void) => {
      const originalStyle: string = window.getComputedStyle(
        document.body
      ).overflow;
      if (isLocked) {
        document.body.style.overflow = "hidden";
      }
      return () => (document.body.style.overflow = originalStyle);
    }, [isLocked]);
  };